module.exports = __webpack_public_path__ + "img/mask.47877800.png";